import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("col", { style: {"width":"5em"} }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("col", { style: {"width":"4em"} }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("col", { style: {"width":"4em"} }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("col", { style: {"width":"4em"} }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("col", { style: {"width":"4em"} }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("col", { style: {"width":"4em"} }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("col", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("col", { style: {"width":"5em"} }, null, -1)
const _hoisted_9 = [
  _hoisted_1,
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("colgroup", null, _hoisted_9))
}